import { MDBAlert, MDBBtn, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { getstreamTeam, updateGlobalSettings } from '../../../apiclients/streamsapi_bridge';
import SaveChanges from '../saveCancel';

function GLobalStreamsTeam({ register, setValue, errors, watch }) {
    const { t, i18n } = useTranslation();

    return (
        <>
            {/* <div className="general-settings pb-2 mb-0">
                Streams Teams
            </div> */}
            <div className="add-numbermain">
                <div className="tel-numbers fw-500">
                    Search Public Teams

                    <p className="mt-1 mb-0 phrecording">
                        Search Public Teams in search
                    </p>
                    <p className='phrecording'>
                        To show/hide Public Teams in the users search
                    </p>
                </div>
                <div>
                    <div className=" ">
                        <label className="switch">
                            <input
                                className="form-control"
                                type="checkbox"
                                {...register("global_settings.streams_settings.search_public_team")}
                            />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>

            <div className="add-numbermain">
                <div className="tel-numbers fw-500">
                    Create Public Teams

                    <p className="mt-1 mb-0 phrecording">Create Public Teams</p>
                    <p className='phrecording'>Users can create Public Teams</p>

                    <a href="https://www.panterranetworks.com/streams-rules" className="text-decoration-underline">
                        Public Teams Rules and Guidelines
                    </a>
                </div>
                <div>
                    <div className=" ">
                        <label className="switch">
                            <input
                                className="form-control"
                                type="checkbox"
                                {...register("global_settings.streams_settings.create_public_teams")}
                            />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>

        </>
    )
}

export default GLobalStreamsTeam
